/**
 * Routes that bypass ScreenGuard and are always accessible to any
 * authenticated user, regardless of the /screens/navigation response.
 *
 * Keep this list narrow — it should contain ONLY system/utility routes
 * that must work for every authenticated user (denial pages, onboarding
 * gates, in-app notifications, user-level settings). Feature screens
 * (dashboard, integrations, catalog-manager, products, lily-agent, etc.)
 * MUST flow through /screens/navigation so that disabling them on the
 * backend cascades to URL access too. See docs/route-permissions.md.
 */
export const UNGUARDED_ROUTES = [
  '/access-denied',
  '/product-not-enrolled',
  '/onboarding',
  '/notification',
  '/settings',
] as const;
